import { GatorBackupActionTypes } from './gatorBackup.types';

const gatorBackupLoading = payload => ({ type: GatorBackupActionTypes.GATOR_BACKUP_LOADING, payload });

const buyGatorBackupRequest = payload => ({ type: GatorBackupActionTypes.GATOR_BACKUP_BUY_REQUEST, payload });
const buyGatorBackupSuccess = payload => ({ type: GatorBackupActionTypes.GATOR_BACKUP_BUY_SUCCESS, payload });
const buyGatorBackupFailure = () => ({ type: GatorBackupActionTypes.GATOR_BACKUP_BUY_FAILURE });
const buyGatorBackupReset = () => ({ type: GatorBackupActionTypes.GATOR_BACKUP_BUY_RESET });

const actions = {
  loading: gatorBackupLoading,
  buy: {
    request: buyGatorBackupRequest,
    success: buyGatorBackupSuccess,
    failure: buyGatorBackupFailure,
    reset: buyGatorBackupReset,
  },
};

const ssoRequest = hostingId => ({
  type: GatorBackupActionTypes.SSO_REQUEST,
  payload: { hostingId },
});

const ssoSuccess = url => ({
  type: GatorBackupActionTypes.SSO_SUCCESS,
  payload: { url },
});

const ssoFailure = error => ({
  type: GatorBackupActionTypes.SSO_FAILURE,
  payload: { error },
});

const gatorBackupActions = {
  ...actions,
  ssoRequest,
  ssoSuccess,
  ssoFailure,
};

export default gatorBackupActions;
